import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
const { persistAtom } = recoilPersist({ key: `FXHUB_RECOIL_STATE`});


export const marketCode = atom({
    key: 'marketCode',
    default: null,
    effects_UNSTABLE: [persistAtom],

});

export const marketCodeList = atom({
    key: 'marketCodeList',
    default: []
});

export const activeFilterName = atom({
    key: 'activeFilterName',
    default: null,
    effects_UNSTABLE: [persistAtom],
});

export const defCountryCode = atom({
    key: 'defCountryCode',
    default: null
});